/* eslint-disable */
export enum MessageKeys {
    NONE,
    ENABLE,
    NO_SUPPORT
}

/* eslint-enable */
